import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Ghost, Home, ArrowLeft } from 'lucide-react';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6 text-center animate-fade-in">
      {/* Visual illustration using icons/glassmorphism */}
      <div className="relative mb-8 group">
        <div className="absolute inset-0 bg-blue-500/10 rounded-full blur-3xl group-hover:bg-blue-500/20 transition-all duration-500"></div>
        <div className="relative w-40 h-40 glass-panel rounded-full flex items-center justify-center border-4 border-white/50 shadow-xl">
          <Ghost size={80} className="text-slate-400/80 group-hover:scale-110 transition-transform duration-300 transform group-hover:-rotate-12" />
        </div>
        <div className="absolute -bottom-2 -right-2 px-4 py-2 bg-red-100 text-red-600 font-black rounded-xl shadow-lg border-2 border-white -rotate-6">
          404
        </div>
      </div>

      <h1 className="text-4xl font-black text-slate-800 mb-3 bg-clip-text text-transparent bg-gradient-to-r from-slate-700 to-slate-900">
        Oops! Trang không tồn tại
      </h1>

      <p className="text-slate-500 text-lg mb-8 max-w-sm mx-auto font-medium">
        Có vẻ như bạn đang cố truy cập một trang chưa được tạo hoặc đã bị xóa.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 w-full max-w-xs">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white border border-slate-200 text-slate-600 font-bold hover:bg-slate-50 hover:border-slate-300 transition-all shadow-sm active:scale-95"
        >
          <ArrowLeft size={18} />
          Quay lại
        </button>

        <button
          onClick={() => navigate('/')}
          className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-indigo-600 text-white font-bold hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-500/30 active:scale-95"
        >
          <Home size={18} />
          Về trang chủ
        </button>
      </div>
    </div>
  );
};
